import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient, ApiClientError } from './client';

export interface DefaultAssignee {
  tenantUserId: string;
  displayName: string;
}

/** Who gets leads, follow-ups and tasks that automations, flows and the system create. */
export interface DefaultAssignees {
  lead: DefaultAssignee | null;
  followUp: DefaultAssignee | null;
  task: DefaultAssignee | null;
}

export interface SetDefaultAssigneesInput {
  leadAssigneeId: string | null;
  followUpAssigneeId: string | null;
  taskAssigneeId: string | null;
}

const KEY = ['team', 'default-assignees'] as const;

export function useDefaultAssignees(enabled = true) {
  return useQuery<DefaultAssignees, ApiClientError>({
    queryKey: KEY,
    queryFn: () => apiClient.get<DefaultAssignees>('/team/default-assignees'),
    enabled,
  });
}

export function useSetDefaultAssignees() {
  const qc = useQueryClient();
  return useMutation<DefaultAssignees, ApiClientError, SetDefaultAssigneesInput>({
    mutationFn: (input) => apiClient.put<DefaultAssignees>('/team/default-assignees', input),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
}
